import type { Dict } from '../i18n';

const dict: Dict = {
  en: {
    loading: 'Loading…',
    notAvailable: 'Not available for your role',
    noAccess: "You don't have access to this section.",
  },
  es: {
    loading: 'Cargando…',
    notAvailable: 'No disponible para tu rol',
    noAccess: 'No tienes acceso a esta sección.',
  },
  de: {
    loading: 'Lädt…',
    notAvailable: 'Für Ihre Rolle nicht verfügbar',
    noAccess: 'Sie haben keinen Zugriff auf diesen Bereich.',
  },
};

export default dict;
